import { IconArrow } from '../../../../../../assets/DesignSystem/SVGComponents';
import { NudosHoverText } from '../../../../../../components/NudosComponents';
import { IlogisticServiceLocation } from '../../../../../../types/services';
import { getLocationDisplayData } from '../../../../../../utils/locationIcons';
import './LogisticsOriginAndDestination.scss';

const LogisticsOriginAndDestination = ({
  origin,
  destination
}: {
  origin?: IlogisticServiceLocation | null;
  destination?: IlogisticServiceLocation | null;
}) => {
  const noDataText = 'Sin datos';
  const originDisplayData = getLocationDisplayData(origin);
  const destinationDisplayData = getLocationDisplayData(destination);

  return (
    <div className="LogisticsOriginAndDestination">
      <div className="origin">
        <div className="iconContainer">
          {originDisplayData.icon}
          <div className="flag" style={{ backgroundImage: originDisplayData.flag }} />
        </div>
        <NudosHoverText
          onlyIfTruncated
          customClassName="locationTitle"
          text={origin?.title || noDataText}
          charactersLimit={22}
        />
      </div>
      <IconArrow className="IconArrow" />
      <div className="destination">
        <div className="iconContainer">
          {destinationDisplayData.icon}
          <div className="flag" style={{ backgroundImage: destinationDisplayData.flag }} />
        </div>
        <NudosHoverText
          onlyIfTruncated
          customClassName="locationTitle"
          text={destination?.title || noDataText}
          charactersLimit={22}
        />
      </div>
    </div>
  );
};

export default LogisticsOriginAndDestination;
